import { modelOptions, prop, Severity } from '@typegoose/typegoose';
import { TimeRange } from './time.model';
import { FilterKeys, FilterType, InputWidthValues } from '@nirvana/shared/dtos/types/generic-dashboards/gz-console';

class Regex {
  @prop({ required: true })
  pattern: string;

  @prop({ required: false })
  options?: string;
}

export class StringConditions {
  @prop({ required: false })
  equals?: string;

  @prop({ required: false, type: String })
  in?: Array<string>;

  @prop({ required: false })
  contains?: string;

  @prop({ required: false, type: Regex, _id: false })
  regex?: Regex;

  @prop({ required: false })
  startsWith?: string;
}

export class IntConditions {
  @prop({ required: false })
  equals?: number;

  @prop({ required: false, type: Number })
  in?: Array<number>;

  @prop({ required: false })
  greaterThan?: number;

  @prop({ required: false })
  lowerThan?: number;

  @prop({ required: false })
  greaterThanOrEqual?: number;

  @prop({ required: false })
  lowerThanOrEqual?: number;
}

class DoubleConditions {
  @prop({ required: false })
  equals?: number;

  @prop({ required: false, type: Number })
  in?: Array<number>;

  @prop({ required: false })
  greaterThan?: number;

  @prop({ required: false })
  lowerThan?: number;

  @prop({ required: false })
  greaterThanOrEqual?: number;

  @prop({ required: false })
  lowerThanOrEqual?: number;
}

class DateConditions {
  @prop({ type: TimeRange, _id: false })
  public timeRange?: TimeRange;
}

class IntEnumConditions {
  in: Array<number>;
}

export class Filter {
  @prop({ required: false, type: DateConditions, _id: false })
  lastDetectedOn?: DateConditions;

  @prop({ required: false, type: IntEnumConditions, _id: false })
  category?: IntEnumConditions;

  @prop({ required: false, type: IntEnumConditions, _id: false })
  actionTaken?: IntEnumConditions;

  @prop({ required: false, type: StringConditions, _id: false })
  deviceName?: StringConditions;

  @prop({ required: false, type: StringConditions, _id: false })
  details?: StringConditions;

  @prop({ required: false, type: StringConditions, _id: false })
  commandLine?: StringConditions;

  @prop({ required: false, type: IntEnumConditions, _id: false })
  threatType?: IntEnumConditions;

  @prop({ required: false, type: StringConditions, _id: false })
  ip?: StringConditions;

  @prop({ required: false, type: IntEnumConditions, _id: false })
  endpointType?: IntEnumConditions;

  @prop({ required: false, type: StringConditions, _id: false })
  user?: StringConditions;

  @prop({ required: false, type: IntEnumConditions, _id: false })
  detectingModule?: IntEnumConditions;

  @prop({ required: false, type: IntEnumConditions, _id: false })
  detectingTechnology?: IntEnumConditions;

  @prop({ required: false, type: StringConditions, _id: false })
  malwareName?: StringConditions;

  @prop({ required: false, type: StringConditions, _id: false })
  sha256?: StringConditions;

  @prop({ required: false, type: IntEnumConditions, _id: false })
  filelessAttack?: IntEnumConditions;

  @prop({ required: false, type: StringConditions, _id: false })
  hostName?: StringConditions;

  @prop({ required: false, type: StringConditions, _id: false })
  company?: StringConditions;

  @prop({ required: false, type: StringConditions, _id: false })
  tags?: StringConditions;
}

class NumberFilterUiConfig {
  @prop({ required: false, enum: InputWidthValues, type: String })
  inputWidth?: InputWidthValues;
}

class DateFilterUiConfig {
  @prop({ required: true })
  activeRange: number | null;

  @prop({ required: false })
  enableSelectAllToDate?: boolean;
}

type AnyFilterUiConfig = DateFilterUiConfig | NumberFilterUiConfig;

@modelOptions({ options: { allowMixed: Severity.ALLOW } })
class GridFilterUiConfiguration {
  @prop({ required: false })
  config?: AnyFilterUiConfig;

  @prop({ required: false })
  class?: string;
}

class FilterValue {
  @prop({ required: true })
  label: string;

  @prop({ required: true })
  value: number | string;
}

@modelOptions({ schemaOptions: { _id: false } })
export class FilterConfig {
  @prop({ required: true, enum: FilterKeys, type: String })
  key: FilterKeys;

  @prop({ required: true })
  name: string;

  @prop({ required: true, enum: FilterType, type: Number })
  type: FilterType;

  @prop({ required: true })
  removable: boolean;

  @prop({ required: false })
  isDefault?: boolean;

  @prop({ required: false })
  enumFilterCanSelectAll?: boolean;

  @prop({ required: false })
  apiType?: string;

  @prop({ required: false })
  ui?: GridFilterUiConfiguration;

  @prop({ required: false })
  values?: Array<FilterValue>;

  @prop({ required: false })
  useActiveCompany?: boolean;
}
